export class Department {
    deptid: number;
    deptname: string;
    depthead: number;
    createdby:number;
    active: number;
}